(function () {

	const GEO_LOCATION_COOKIE = 'geoLocation';
	const GEO_CONTINENT_COOKIE = 'geoContinent';
	const GEO_COUNTRY_CODE = 'geoCountryCode';
	const GEO_VERSION_COOKIE = 'geoVersionV3'; // Force cache

	function getUsersCountryByIP() {
		const IP_API_KEY = window['IP_API_KEY'];
		if (!IP_API_KEY) {
			console.log('API Key not found.')
			return Promise.resolve();
		}

		const IP_API_URL_QUERY = "https://pro.ip-api.com/json/?key=" + IP_API_KEY + "&fields=status,message,country,countryCode,continent";

		return fetch(IP_API_URL_QUERY)
			.then((response) => response.json())
			.then((response) => {
				if (response.status !== 'success') {
					return false;
				}

				return {
					country: response.country,
					countryCode: response.countryCode,
					continent: response.continent,
				};
			});
	}

	function initCountryLogic() {
		return new Promise((resolve) => {
			if (!getCookie(GEO_LOCATION_COOKIE) || !getCookie(GEO_VERSION_COOKIE)) {
				return getUsersCountryByIP()
					.then((data) => {
						if (!data || !data.country) {
							return;
						}

						setCookie(GEO_LOCATION_COOKIE, data.country, 1);
						setCookie(GEO_CONTINENT_COOKIE, data.continent, 1);
						setCookie(GEO_COUNTRY_CODE, data.countryCode, 1);
						setCookie(GEO_VERSION_COOKIE, 'true', 1);
					})
					.then(() => resolve());
			}

			resolve();
		});
	}

	function getCountry() {
		return initCountryLogic()
			.then(() => getCookie(GEO_LOCATION_COOKIE));
	}

	function getContinent() {
		return initCountryLogic()
			.then(() => getCookie(GEO_CONTINENT_COOKIE));
	}

	// Public API

	window.getCountry = getCountry;
	window.getContinent = getContinent;

})();
